import axiosIntents from '@/utils/axios-intents'

import insertScript from '@/helpers/insert-script'

const PAYMENT_PLATFORM = 'braintree'

const state = {
    braintree: null,
    braintree_hosted_fields: null,
    braintree_client_secret: null,

    initializers: {
        braintree: null,
        braintree_hosted_fields: null,
        braintree_with_hosted_fields: null,

        braintree_client_secret: null,
    },
}

const getters = {
    braintree: state => state.braintree,
    braintree_hosted_fields: state => state.braintree_hosted_fields,
    braintree_client_secret: state => state.braintree_client_secret,
}

const mutations = {
    saveBraintree(state, braintree) {
        state.braintree = braintree
    },
    saveBraintreeHostedFields(state, braintree_hosted_fields) {
        state.braintree_hosted_fields = braintree_hosted_fields
    },
    saveBraintreeClientSecret(state, braintree_client_secret) {
        state.braintree_client_secret = braintree_client_secret
    },

    setInitializers(state, initializers) { // { [name]: promise, ... }
        for (const name in initializers) {
            if (name in state.initializers) {
                state.initializers[name] = initializers[name]
            }
        }
    },
    resetInitializer(state, name) {
        state.initializers[name] = null
    },

    resetBraintreeClientSecret(state) {
        state.braintree_client_secret = null
        state.initializers.braintree_client_secret = null
    },
}

const actions = {
    braintreeInitClient({state, commit}) {
        const initializer_name = 'braintree'

        if (state.initializers[initializer_name]) {
            return state.initializers[initializer_name]
        } else {
            if (state[initializer_name]) {
                return Promise.resolve(state[initializer_name])
            } else {
                const initializer = insertScript('https://js.braintreegateway.com/web/3.120.2/js/client.min.js', 'Braintree', 'braintree')
                    .then(braintree => {
                        commit('saveBraintree', braintree)

                        return Promise.resolve(state[initializer_name])
                    })
                    .finally(() => {
                        commit('resetInitializer', initializer_name)
                    })
                commit('setInitializers', { [initializer_name]: initializer })

                return Promise.resolve(state.initializers[initializer_name])
            }
        }
    },

    braintreeInitHostedFields({state, commit}) {
        const initializer_name = 'braintree_hosted_fields'

        if (state.initializers[initializer_name]) {
            return state.initializers[initializer_name]
        } else {
            if (state[initializer_name]) {
                return Promise.resolve(state[initializer_name])
            } else {
                const initializer = insertScript('https://js.braintreegateway.com/web/3.120.2/js/hosted-fields.min.js', 'Braintree Hosted Fields')
                    .then(() => {
                        commit('saveBraintreeHostedFields', true)

                        return Promise.resolve(state[initializer_name])
                    })
                    .finally(() => {
                        commit('resetInitializer', initializer_name)
                    })
                commit('setInitializers', { [initializer_name]: initializer })

                return Promise.resolve(state.initializers[initializer_name])
            }
        }
    },
    
    braintreeInitWithHostedFields({state, commit, dispatch}) {
        const initializer_name = 'braintree_with_hosted_fields'

        if (state.initializers[initializer_name]) {
            return state.initializers[initializer_name]
        } else {
            const initializer = Promise.all([
                    dispatch('braintreeInitClient'),
                    dispatch('braintreeInitHostedFields')
                ]).then(([braintree]) =>
                    Promise.resolve(braintree)
                ).finally(() => {
                    commit('resetInitializer', initializer_name)
                })
            commit('setInitializers', { [initializer_name]: initializer })

            return Promise.resolve(state.initializers[initializer_name])
        }
    },



    braintreeSetupIntentClientSecret({state, getters, commit, dispatch}) {
        const initializer_name = 'braintree_client_secret'

        if (state.initializers[initializer_name]) {
            return state.initializers[initializer_name]
        } else {
            if (getters[initializer_name]) {
                return Promise.resolve(getters[initializer_name])
            } else {
                const initializer = dispatch('setupIntentClientSecret', PAYMENT_PLATFORM)
                    .then(client_secret => {
                        if (state.initializers.braintree_client_secret === initializer) {
                            commit('saveBraintreeClientSecret', client_secret)
                        }

                        return Promise.resolve(client_secret)
                    })
                    .finally(() => {
                        commit('resetInitializer', initializer_name)
                    })
                commit('setInitializers', { [initializer_name]: initializer })

                return Promise.resolve(state.initializers[initializer_name])
            }
        }
    },

    braintreeSavePaymentMethod({getters}, payment_method) {
        return axiosIntents.post('/billing/payment_method', {
            ClientSecret: payment_method.nonce,
            CustomerUUID: getters.current_account_uid,
            PaymentGateway: PAYMENT_PLATFORM,
        })
    },

    braintreeConfirmPayment({getters}, { client_secret, payment_method, payment_method_id }) {
        return axiosIntents.post('/billing/payment', {
            ClientSecret: payment_method?.nonce || payment_method_id || getters.paymentMethodIDByClientSecret(client_secret),
            CustomerUUID: getters.current_account_uid,
            PaymentGateway: PAYMENT_PLATFORM,
            SetupID: client_secret,
        })
    },
}

export default {
	state,
	getters,
	mutations,
	actions,
}